import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  PrintBlockContainerOption,
  PrintBlockInputInterface,
  PrintBlockInputNewDataEvent,
  PrintBlockItem,
} from 'src/app/shared';

@Component({
  selector: 'shared-print-block-container',
  templateUrl: './print-block-container.component.html',
  styleUrls: ['./print-block-container.component.sass'],
})
export class PrintBlockContainerComponent implements OnInit, OnChanges {
  @Input('printBlocks') printBlocks!: PrintBlockItem[];
  @Output('printBlocksChange') printBlocksChange!: EventEmitter<
    PrintBlockItem[]
  >;

  @Input() options!: PrintBlockContainerOption;
  @Output() optionsChange = new EventEmitter<PrintBlockContainerOption>();

  @Input() instructionBlocks!: PrintBlockInputInterface[];
  @Output() instructionBlocksChange = new EventEmitter<
    PrintBlockInputInterface[]
  >();

  @Output('change') onChange: EventEmitter<SimpleChanges | null>;

  public isSingle!: boolean;
  private recordOfChildItems: Record<string, PrintBlockItem[]> = {};

  // constructor -------------------------------------------->

  constructor() {
    this.printBlocksChange = new EventEmitter();
    this.onChange = new EventEmitter();
  }

  async ngOnInit(): Promise<void> {
    this.construct();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.construct();
    this.onChange.emit(changes);
  }

  // Public methods ----------------------------------------->

  public updateData(event: PrintBlockInputNewDataEvent) {
    const data = event.data;
    const type = event.type;

    this.recordOfChildItems[type.id] = data;
    this.emitDataChange();
  }

  // Private methods ---------------------------------------->

  private construct() {
    this.setInstructionBlocks();
    this.setMultipleOrSingle();
  }

  private setMultipleOrSingle() {
    if (this.options && this.options?.blocks.length === 1) {
      this.isSingle = true;
    } else {
      this.isSingle = false;
    }
  }

  private setInstructionBlocks() {
    if (this.options) {
      this.instructionBlocks = this.options.blocks;
    }
  }

  private emitDataChange() {
    const flatData = this.flatRecordedData();
    if (!flatData) return;

    this.printBlocksChange.emit(flatData);
  }

  private flatRecordedData() {
    const keys = Object.keys(this.recordOfChildItems);
    if (keys.length === 0) return;

    const flatPrintBlockItems: PrintBlockItem[] = [];

    keys.forEach((key) => {
      this.recordOfChildItems[key].forEach((printBlock) => {
        flatPrintBlockItems.push(printBlock);
      });
    });

    return flatPrintBlockItems;
  }

  onOnDestroy() {}
}
